var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeRel5B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2641_6772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 47C36.9787 47 47.5 36.4787 47.5 23.5C47.5 10.5213 36.9787 0 24 0C11.0213 0 0.5 10.5213 0.5 23.5C0.5 36.4787 11.0213 47 24 47Z",
    fill: "#F2F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8575 17.4145C30.1512 17.1457 30.5422 16.9971 30.9478 17C31.3534 17.003 31.7419 17.1573 32.0314 17.4303C32.3209 17.7033 32.4887 18.0737 32.4995 18.4634C32.5102 18.8531 32.363 19.2315 32.0889 19.5188L23.7681 29.5196C23.625 29.6677 23.4523 29.7866 23.2603 29.8691C23.0684 29.9515 22.8611 29.996 22.6508 29.9997C22.4406 30.0035 22.2317 29.9664 22.0367 29.8908C21.8416 29.8152 21.6645 29.7026 21.5158 29.5597L15.9978 24.2567C15.8441 24.1191 15.7209 23.9531 15.6354 23.7687C15.5499 23.5844 15.5039 23.3853 15.5002 23.1835C15.4965 22.9817 15.5352 22.7812 15.6138 22.594C15.6925 22.4069 15.8096 22.2368 15.9581 22.0941C16.1066 21.9514 16.2835 21.8388 16.4783 21.7632C16.673 21.6876 16.8816 21.6505 17.0917 21.6541C17.3017 21.6576 17.5088 21.7018 17.7006 21.784C17.8925 21.8661 18.0652 21.9846 18.2083 22.1323L22.5752 26.327L29.8179 17.4586C29.8309 17.4431 29.8427 17.4284 29.8575 17.4145Z",
    fill: "#399948"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2641_6772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeRel5B);
export default __webpack_public_path__ + "static/media/icone-rel-5B.9aaf0d808e202e32c4efe654f61a040b.svg";
export { ForwardRef as ReactComponent };